import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import Page from '@Containers/Page';
import { LinkElement } from '@els/els-react--link-element';
import { Icon } from '@els/els-react--icon';
import RouteChangeTracking from '@Services/RouteChangeTracking';

import { supportCenterLink } from './LoginLimitConstants';

function LoginLimit({ message }) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
  }, []);

  return (
    <Page withHeader headerType="clean" withFooter pageClassName="login-limit-page" className="react-page-static__wrapper">
      <h1 className="react-page-static__heading">
        <Icon sprite="Settings" isDecorative />
        &nbsp; Too many current active logins.
      </h1>
      <div className="react-page-static__content">
        <p>{message}</p>
        <p>
          <LinkElement
            data-e2e="contact-support-team"
            href={supportCenterLink}
            className="e2e-contact-support-team"
            isExternal
            iconSprite="ChevronRight"
            iconSize="s"
            iconRight>
            Contact Support Team
          </LinkElement>
        </p>
      </div>
    </Page>
  );
}

LoginLimit.propTypes = {
  message: PropTypes.string,
};

export default withCombinedRouteParams(LoginLimit);
